// extracted by mini-css-extract-plugin
export default {"header":"BatchDetails_header__rVFYX","fileButtons":"BatchDetails_fileButtons__y8fLc","errorNoItems":"BatchDetails_errorNoItems__v5kMq"};